import { createAsyncThunk } from '@reduxjs/toolkit';
import { HomepageContent } from '@wix/wix-help-widget-common/homepage';

import { getHomepageContent } from '../../homepage/api';
import { widgetSDK } from '../../sdk/widgetSDK';
import { fedopsLogger } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

export const loadHomepageContent = createAsyncThunk<HomepageContent, HttpClientFactory>(
  'loadHomepageContent',
  async (httpClient: HttpClientFactory) => {
    fedopsLogger.interactionStarted('fetching-homepage-content');

    const { userExperience } = await widgetSDK.getContext();
    const homepageContent = await getHomepageContent(httpClient, userExperience);

    fedopsLogger.interactionEnded('fetching-homepage-content');
    return homepageContent;
  },
);
